export default __webpack_public_path__ + "static/freight-big-pro-black-2b5fddd67326a8dd2d5a7935175ab0cb.woff2";